if (!customElements.get("product-features-bar")) {
  customElements.define(
    "product-features-bar",
    class ProductFeaturesBar extends HTMLElement {
      connectedCallback() {
        this.sliderContainer = this.querySelector(".swiper-container");
        this.enableAutoplay = this.dataset.autoplay !== "false";
        this.autoplaySpeed = parseFloat(this.dataset.autoplaySpeed) || 4;
        this.slider = null;

        document.addEventListener("matchMobile", () => this.initSlider());
        document.addEventListener("unmatchMobile", () => this.destroySlider());
        if (MinimogTheme.config.mqlMobile) this.initSlider();
      }

      initSlider() {
        if (this.slider) return;
        this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
          slidesPerView: "auto",
          spaceBetween: 17,
          loop: true,
          speed: 500,
          threshold: 2,
          autoplay: this.enableAutoplay
            ? {
                delay: this.autoplaySpeed * 1000,
                disableOnInteraction: false,
              }
            : false,
        });
      }

      destroySlider() {
        if (!this.slider) return;
        this.slider.destroy(true, true);
        this.slider = null;
      }
    }
  );
}
